<template>
    <div class="ck-form-item" :class="{'ck-form-item-error': !checkValidity()
                ,'ck-form-item-valid': checkValidity()
                ,'ck-form-item-left': labelPosition === 'left'
                ,'ck-form-item-right': labelPosition === 'right'
                ,'ck-form-item-top': labelPosition === 'top'
            }">
        <div v-if="!isReadOnly">
            <label class="ck-form-item-label" :class="{'ck-form-item-label-required': required}" :style="{width: labelWidth}" v-if="label">{{ label }}</label>
            <slot></slot>
        </div>
        <div v-if="isReadOnly">
            <ck-informations :label="label" :display="display"></ck-informations>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
export default Vue.component('ck-form-item', {
    props: {
        model: {
            type: Object
        },
        validators: {
            type: Object,
            default: () => { }
        },
        label: {
            type: String,
            default: ''
        },
        labelWidth: {
            type: String,
            default: ''
        },
        labelPosition: {
            type: String,
            default: ''
        },
        requiredLabel: {
            type: Boolean,
            default: undefined
        },
        display: {
            default: ''
        },
        readOnly: {
            type: Boolean,
            default: undefined
        }
    },

    computed: {
        ckForm() {
            return this.getCkForm(this);
        },
        computedValidators() {
            if (!this.validators) return [];
            return Array.isArray(this.validators) ? this.validators : [this.validators];
        },
        flattenValidators() {
            return this.computedValidators.concat(_.flatten(_.map(this.childValidators, 'computedValidators')));
        },
        required() {
            return this.requiredLabel || _.some(this.flattenValidators, (item) => item.validator === this.$ckValidator.required);
        },
        isReadOnly() {
            if(this.readOnly != undefined) return this.readOnly;
            
            return this.ckForm.readOnly;
        }
    },

    data: function () {
        return {
            childValidators: {}
        };
    },

    beforeMount: function () {
        this.ckForm.register(this);
    },
    beforeDestroy: function () {
        this.ckForm.unregister(this);
    },

    methods: {
        getCkForm(x) {
            if (!x.$parent) return undefined;
            if (x.$parent.$options._componentTag === 'ck-form') return x.$parent;
            
            return this.getCkForm(x.$parent);
        },
        register(childComponent) {
            this.$set(this.childValidators, childComponent._uid, childComponent);
        },
        unregister(childComponent) {
            delete this.childValidators[childComponent._uid];
        },
        checkValidity() {
            let isValid = _.every(this.childValidators, (item) => item.checkValidity());
            if (!isValid) return false;

            return _.every(this.computedValidators, (item) => !item.isDirty || item.isValid);
        }
    },

    watch: {
        validators: {
            handler: function (newValue, oldValue) {
                this.ckForm._specificValidate('change', this._uid);
            },
            deep: true
        }
    }
});
</script>

<style>
.ck-form-item {
    margin-bottom: 12px;
}

.ck-form-item-label {
    text-align: right;
    vertical-align: middle;
    float: left;
    font-size: 14px;
    line-height: 1;
    padding: 11px 12px 11px 0;
    box-sizing: border-box;
}

.ck-form-left .ck-form-item-label {
    text-align: left;
}

.ck-form-top .ck-form-item-label {
    float: none;
    display: inline-block;
    text-align: left;
    padding: 0 0 10px 0;
}


.ck-form-item-right.ck-form-item .ck-form-item-label {
    text-align: right;
    vertical-align: middle;
    float: left;
    font-size: 14px;
    color: rgb(78, 106, 72);
    line-height: 1;
    padding: 11px 12px 11px 0;
    box-sizing: border-box;
}

.ck-form-item-left.ck-form-item .ck-form-item-label {
    text-align: left;
}

.ck-form-item-top.ck-form-item .ck-form-item-label {
    float: none;
    display: inline-block;
    text-align: left;
    padding: 0 0 10px 0;
}


.ck-form-item-label-required::before {
    content: '*';
    color: #ff4949;
    margin-right: 4px;
}


.ck-form-left .ck-form-item-label-required::before {
    content: '';
    color: #ff4949;
    margin-right: 0px;
}

.ck-form-left .ck-form-item-label-required::after {
    content: '*';
    color: #ff4949;
    margin-left: 4px;
}

.ck-form-top .ck-form-item-label-required::before {
    content: '';
    color: #ff4949;
    margin-right: 0px;
}

.ck-form-top .ck-form-item-label-required::after {
    content: '*';
    color: #ff4949;
    margin-left: 4px;
}

.ck-form-item-left .ck-form-item-label-required::before {
    content: '';
    color: #ff4949;
    margin-right: 0px;
}

.ck-form-item-left .ck-form-item-label-required::after {
    content: '*';
    color: #ff4949;
    margin-right: 0px;
    margin-left: 4px;
}

.ck-form-item-top .ck-form-item-label-required::before {
    content: '*';
    color: #ff4949;
    margin-right: 4px;
    margin-left: 4px;
}

.ck-form-item-top .ck-form-item-label-required::after {
    content: '';
    color: #ff4949;
    margin-left: 0px;
}

.ck-form-item-right .ck-form-item-label-required::before {
    content: '';
    margin-left: 0px;
}

.ck-form-item-right .ck-form-item-label-required::before {
    content: '*';
    color: #ff4949;
    margin-right: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/ck-form/ck-form-item.vue